import * as React from "react";
import Modal from "@mui/material/Modal";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

import { getFormikError } from "../../helpers";
import Typography from "@mui/material/Typography";

const SettingsModal = ({ isOpen, closeModal, formik }) => {
  const getError = (fieldName) => getFormikError(fieldName, formik);

  return (
    <Modal open={isOpen} onClose={closeModal}>
      <Container
        maxWidth="sm"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "white",
          borderRadius: "5px",
          maxHeight: { xs: "100%", sm: "90vh" },
          overflow: "auto",
        }}
      >
        <Typography sx={{ my: 3 }} variant="h5" component="h1" align="center">
          Настройки
        </Typography>
        <Stack spacing={4} direction="column">
          <TextField
            variant="outlined"
            label="Как быстро проверяем, с"
            type="number"
            {...formik.getFieldProps("checkInterval")}
            error={!!getError("checkInterval")}
            helperText={getError("checkInterval")}
          />
          <TextField
            variant="outlined"
            label="Времена отправления поездов"
            {...formik.getFieldProps("departureTimes")}
            error={!!getError("departureTimes")}
            helperText={getError("departureTimes")}
          />
          <TextField
            variant="outlined"
            label="Город отправления"
            {...formik.getFieldProps("stationFrom")}
            error={!!getError("stationFrom")}
            helperText={getError("stationFrom")}
          />
          <TextField
            variant="outlined"
            label="Город прибывания"
            {...formik.getFieldProps("stationTo")}
            error={!!getError("stationTo")}
            helperText={getError("stationTo")}
          />
          <TextField
            variant="outlined"
            label="Дата отправления"
            type="date"
            {...formik.getFieldProps("departureDate")}
            error={!!getError("departureDate")}
            helperText={getError("departureDate")}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            variant="outlined"
            label="id в телеграм"
            {...formik.getFieldProps("telegramChatId")}
            error={!!getError("telegramChatId")}
            helperText={getError("telegramChatId")}
          />
          <TextField
            variant="outlined"
            label="Минимальная цена билета"
            {...formik.getFieldProps("ticketPriceMin")}
            error={!!getError("ticketPriceMin")}
            helperText={getError("ticketPriceMin")}
          />
          <TextField
            variant="outlined"
            label="Максимальная цена билета"
            {...formik.getFieldProps("ticketPriceMax")}
            error={!!getError("ticketPriceMax")}
            helperText={getError("ticketPriceMax")}
          />
        </Stack>
        <Stack
          direction="row"
          spacing={5}
          sx={{ justifyContent: "center", my: 4 }}
        >
          <Button onClick={closeModal} variant="outlined">
            Отмена
          </Button>
          <Button onClick={formik.handleSubmit} variant="contained">
            Едем
          </Button>
        </Stack>
      </Container>
    </Modal>
  );
};

export default SettingsModal;
